import { Layout } from "components/UI";

import mainRoutes from "routes/mainRoutes";
import authUserRoutes from "routes/authUserRoutes";
import dashboardRoutes from "routes/dashboardRoutes";
import employeeRoutes from "routes/employeeRoutes";
import cashReceiptRoutes from "routes/cashReceiptRoutes";
import reimbursementRoutes from "routes/reimburseRoutes";
import pettyCashRoutes from "routes/pettyCashRoutes";
import presenceApprovalRoutes from "routes/presenceApprovalRoutes";
import scheduleRoutes from "routes/scheduleRoutes";
import attendanceRoutes from "routes/attendanceRoutes";
import leaveRoutes from "routes/leaveRoutes";
import clientVisitRoutes from "routes/clientVisitRoutes";
import trackingRoutes from "routes/trackingRoutes";
import recruitmentRoutes from "routes/recruitmentRoutes";
import payrollRoutes from "routes/payrollRoutes";
import approvalRoutes from "routes/approvalRoutes";
import timelineRoutes from "routes/timelineRoutes";
import clientRoutes from "routes/clientRoutes";
import reportRoutes from "routes/reportRoutes";
import accountingRoutes from "routes/accountingRoutes";
import taskRoutes from "routes/taskRoutes";
import kpiRoutes from "routes/kpiRoutes";
import faqRoutes from "routes/faqRoutes";
import settingRoutes from "routes/settingRoutes";
import referralRoutes from "routes/referralRoutes";
import companyRoutes from "routes/companyRoutes";
import notFoundRoutes from "routes/notFoundRoutes";

const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      ...mainRoutes,
      ...authUserRoutes,
      ...dashboardRoutes,
      ...employeeRoutes,
      ...presenceApprovalRoutes,
      ...scheduleRoutes,
      ...attendanceRoutes,
      ...leaveRoutes,
      ...clientVisitRoutes,
      ...trackingRoutes,
      ...recruitmentRoutes,
      ...payrollRoutes,
      ...cashReceiptRoutes,
      ...reimbursementRoutes,
      ...pettyCashRoutes,
      ...approvalRoutes,
      ...timelineRoutes,
      ...clientRoutes,
      ...reportRoutes,
      ...accountingRoutes,
      ...taskRoutes,
      ...kpiRoutes,
      ...settingRoutes,
      ...faqRoutes,
      ...referralRoutes,
      ...companyRoutes,
      ...notFoundRoutes,
    ],
  },
];

export default routes;
